export enum RespondEnum {
    ToAgent,
    ToClient,
    DoNotSend 
}